export enum Cookie {
    Locale = 'yc.locale',
    CountryCode = 'yc.countryCode',
    AbTestExperiment = 'yc.experiments',
}
